export default __webpack_public_path__ + "img/eauEjkLR.0b06843b.svg";